import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.css'
})
export class ErrorPageComponent implements OnInit{
  
  redirectUrl = undefined;
  errorType = "";

  constructor(
    private route: ActivatedRoute,
  ){}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    const errorTypeParam = params['errorType'];
    if (errorTypeParam === "unauthorized") this.errorType = "ERROR.UNAUTHORIZED";
    else if (errorTypeParam === "malformed") this.errorType = "ERROR.MALFORMED";
    else this.errorType = "ERROR.GENERIC_ERROR";
    this.redirectUrl = params['returnUrl'];
  }

  redirect() {
    if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
    }
  }

}
